// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-visibility-select--FLttT .image-select{min-width:190px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-visibility-select": "video-visibility-select--FLttT"
};
export default ___CSS_LOADER_EXPORT___;
